app.directive('teamSetup', function ($location, progressBarService, teamManagementService) {
    return {
        restrict: 'E',
        templateUrl: '../app/modules/templates/teamSetup.html',
        link: function (scope, element, attr) {
            scope.selectedInstitute = {
                InstitutionId: 0,
                InstitutionName: '',
                isAffiliationExists: false,
                userDefinedAffiliation: ''
            };

            scope.hideModal = function () {
                $('#teamSetup').modal('hide');
                $location.path('/landing')
            }

            scope.selectAffiliation = function () {
                $('#affiliationName').val('');
                scope.selectedInstitute.userDefinedAffiliation = "";
                scope.selectedInstitute.InstitutionId = scope.profileData.InstitutionId;
                if (!scope.selectedInstitute.isAffiliationExists) {
                    scope.selectedInstitute.InstitutionName = scope.profileData.InstitutionName;
                } else {
                    if (scope.profileData.InstitutionName.length == 0) {
                        scope.selectedInstitute.isAffiliationExists = false
                    }
                    scope.selectedInstitute.userDefinedAffiliation = scope.profileData.InstitutionName;
                }

                $('#affiliation').modal('show');
            };

            scope.profileData = {
                InstitutionId: "",
                InstitutionName: "",
                teamDisplayName: ""
            }

            scope.proceedTeamSetup = function () {
                progressBarService.showProgressBar();
                scope.isDisabled = true;

                var data = {
                    eSpectraTeamAffiliationID: parseInt(scope.profileData.InstitutionId) > 0 ? scope.profileData.InstitutionId : 1,
                    eSpectraTeamAffiliationName: scope.profileData.InstitutionName,
                    eSpectraTeamName: scope.profileData.teamDisplayName
                }

                teamManagementService.saveIndividualTeam(data).then(function (response) {
                    if (response != null && response.data.message != undefined) {
                        scope.modalMessage = response.data.message;
                        scope.isModalError = true;
                        scope.isDisabled = false;
                        progressBarService.hideProgressBar();
                    }
                    else {
                        $location.path('/landing')
                    }
                });
            }
        }
    }
});